import React from 'react';

import { Calendar } from '@/components/ui/calendar';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';

import Day from './availabilityCalendar/Day';

const AvailabilityCalendar = ({ availabilities, onSelect, isPublicView }) => {
  const [month, setMonth] = React.useState(new Date());

  const years = Array.from(
    { length: 10 },
    (_, i) => new Date().getFullYear() + i
  );

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  return (
    <div className="w-full flex flex-col">
      <div className="flex gap-2 p-3">
        <Select
          onValueChange={(value) =>
            setMonth((prev) => new Date(prev.getFullYear(), parseInt(value)))
          }
        >
          <SelectTrigger className="w-[110px]">
            <SelectValue placeholder="Month" />
          </SelectTrigger>
          <SelectContent>
            {months.map((month, index) => (
              <SelectItem key={month} value={index.toString()}>
                {month}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Select
          onValueChange={(value) =>
            setMonth((prev) => new Date(parseInt(value), prev.getMonth()))
          }
        >
          <SelectTrigger className="w-[90px]">
            <SelectValue placeholder="Year" />
          </SelectTrigger>
          <SelectContent>
            {years.map((year) => (
              <SelectItem key={year} value={year.toString()}>
                {year}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <Calendar
        mode="single"
        month={month}
        onMonthChange={setMonth}
        disabled={(date) => date < new Date()}
        initialFocus
        className="w-full"
        classNames={{
          table: 'mx-auto'
        }}
        components={{
          Day: ({ date, ...props }) => (
            <Day
              date={date}
              displayMonth={props.displayMonth}
              handleSelect={onSelect}
              availabilities={availabilities}
              isPublicView={isPublicView}
            />
          )
        }}
      />
      <div className="mt-4">
        <Button
          onClick={() => setMonth(new Date())}
          variant="outline"
          size="sm"
        >
          Today
        </Button>
      </div>
    </div>
  );
};

export default AvailabilityCalendar;
